import { createCapHeader, createMeta } from "../../../components/hocs/createCapHeader";

const title = "Calendar";
export const CalendarHeader = createCapHeader(title, "/", true);
export const CalendarMeta = createMeta(title);
